import { UserSchema, ZodCreateUserSchema, ZodUpdateUserSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type User = UserSchema;

export const getUsers = async (): Promise<User[]> => {
  const response = await apiClient.get<{ users: User[] }>("/api/user");
  return response.data.users;
};

export const getActiveUser = async (): Promise<User> => {
  const response = await apiClient.get<User>("/api/user/active");
  return response.data;
};

export const createUser = async (userData: ZodCreateUserSchema): Promise<User> => {
  const response = await apiClient.post<{ user: User }>("/api/user", userData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.user;
};

export const updateUser = async (userData: ZodUpdateUserSchema): Promise<User> => {
  const response = await apiClient.put<{ user: User }>(`/api/user/${userData.id}`, userData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.user;
};

export const deleteUser = async (userId: string): Promise<{ message: string; user: User }> => {
  const response = await apiClient.delete<{ message: string; user: User }>(`/api/user/${userId}`);
  return response.data;
};
